<template>
    <div>
        <div style="flex:1; overflow:auto;background-color: white; border-top-left-radius: 20px; border-top-right-radius:20px; padding:20px;">
            <div style="display:flex; padding:10px 0px;">
                <div style="width:50px;" @click="() => { $GlobalStore.closeLastModal() }">
                    <img :src="require('@/assets/images/mypage/ico-close.png')" style="width:20px;">
                </div>
                <div style="flex:1; display:grid;place-items: center; color:#101014; font-size:20px; font-weight:500;">회원가입</div>
                <div style="width:50px;"></div>
            </div>
            <div style="height:1px; background-color: #F5F5F5; margin:0px -20px 30px -20px"></div>

            <FormInput2 label="이름" v-model="name" />
            <div class="input_explain" style="">정확한 이름을 기재해주세요.</div>

            <div style="color:#101014; font-size:12px; margin-bottom:15px; margin-top:40px;">서비스 동의</div>
            <div class="agree_check_wrap" @click="toggleCheck(1)">
                <div class="agree_content"><span style="color: var(--color-main);">이용약관, 개인정보 수집 및 이용</span>에 동의합니다.(필수)</div>
                <div class="check_border">
                    <img v-if="agree[1]" class="check_img" :src="require('@/assets/img/check_filter.png')">
                </div>
            </div>
            <div class="agree_check_wrap" @click="toggleCheck(2)">
                <div class="agree_content">위치기반 서비스 이용약관에 대해 동의합니다.(필수)</div>
                <div class="check_border">
                    <img v-if="agree[2]" class="check_img" :src="require('@/assets/img/check_filter.png')">
                </div>
            </div>
            <div class="agree_check_wrap" @click="toggleCheck(3)">
                <div class="agree_content">마케팅 메시지 수신을 원합니다.(선택)</div>
                <div class="check_border">
                    <img v-if="agree[3]" class="check_img" :src="require('@/assets/img/check_filter.png')">
                </div>
            </div>
            <div @click="() => { if (is_regist_active) regist(); }" class="regist_btn" :class="{ active: is_regist_active }" style="">동의하고 계속 진행하기</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import FormInput2 from "../common/FormInput2";

export default {
    name: "KaKaoRegist",
    components: { FormInput2 },
    props: {
        id: String,
        mode: Number,
    },
    data() {
        return {
            name: '',
            phone: '',
            isSendAuthNumber: false,
            isAuthNumberChecked: false,
            authNumber: '',
            // zipCode : '',
            // address : '',
            // addressDetail : ''
            agree: {
                0: false,
                1: false,
                2: false,
                3: false
            },
            sex: '',
            is_regist_active: false,
        }
    },
    watch: {
        name() {
            this.checkAllFilled();
        },
        'agree.1': function () {
            this.checkAllFilled();
        },
        'agree.2': function () {
            this.checkAllFilled();
        }
    },
    methods: {
        checkAllFilled() {
            if (this.name.length > 0 && this.agree[1] && this.agree[2]) {
                this.is_regist_active = true;
            } else {
                this.is_regist_active = false;
            }
        },
        toggleCheck(index) {
            this.agree[index] = !this.agree[index];

        },
        checkAll() {
            const agreeCnt = Object.keys(this.agree).length;
            let flag = true;
            if (this.agree[0]) flag = false;

            for (let i = 0; i < agreeCnt; i++) {
                this.agree[i] = flag;
            }
        },
        async regist() {
            if (!this.agree[1]) {
                this.$GlobalStore.showAlert('이용약관, 개인정보 수집 및 이용에 동의해주세요.');
                return;
            }

            if (!this.agree[2]) {
                this.$GlobalStore.showAlert('위치기반 서비스 이용약관에 대해 동의해주세요.');
                return;
            }

            // if(!this.agree[3]){
            //     this.$GlobalStore.showAlert('개인정보 제 3자 제공에 대한 동의를 해주세요.');
            //     return;
            // }

            if (!this.name) {
                this.$GlobalStore.showAlert('이름을 입력해주세요.');
                return;
            }

            if (!this.$Util.checkName(this.name)) {
                this.$GlobalStore.showAlert('이름은 한글만 가능합니다.');
                return;
            }

            // if(this.sex === ''){
            //     alert('성별을 선택해주세요.');
            //     return ;
            // }
            //
            // if(!this.isAuthNumberChecked){
            //     alert('인증번호를 확인해주세요.');
            //     return;
            // }

            // if(!this.id){
            //     this.$GlobalStore.showAlert('아이디가 존재하지 않습니다. 고객센터에 문의해주세요.');
            //     return;
            // }

            const parameters = {};
            parameters.name = this.name;
            // parameters.phone = this.phone;
            parameters.mode = this.mode;
            parameters.id = this.id;
            // parameters.authNumber = this.authNumber;
            // parameters.sex = this.sex;

            try {
                const res = await axios.post('/regist/kakao', parameters);
                if (res.data.code === 0) {
                    localStorage.removeItem('marketing_agree');
                    this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                    this.$GlobalStore.closeLastModal(true);
                    this.$GlobalStore.closeLastModal(true);
                    await this.$Util.checkAfterLogin(true);
                } else {
                    alert(res.data.msg);
                }
            } catch (e) {
                alert(JSON.stringify(e));
            }
        },
        // async sendAuthNumber(){
        //     if(!this.phone){
        //         this.$GlobalStore.showAlert('휴대폰번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     const parameters = {};
        //     parameters.phone = this.phone;
        //
        //     const res = await this.$Axios.post('/api/auth/number', parameters);
        //     if(res.data.code === 0){
        //         this.isSendAuthNumber = true;
        //         this.isAuthNumberChecked = false;
        //         this.$GlobalStore.showAlert('전송되었습니다.');
        //     }else {
        //         alert(res.data.msg);
        //     }
        // },
        // async checkAuthNumber(){
        //     if(!this.authNumber){
        //         alert('인증번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     if(!this.phone){
        //         alert('휴대폰번호를 입력해주세요.');
        //         return;
        //     }
        //
        //     const parameters = {};
        //     parameters.phone = this.phone;
        //     parameters.authNumber = this.authNumber;
        //
        //     const res = await this.$Axios.post('/api/auth/check', parameters);
        //     if(res.data.code === 0){
        //         alert('인증되었습니다.');
        //         this.isAuthNumberChecked = true;
        //     }else {
        //         alert(res.data.msg);
        //     }
        // },
    },
    created() {
        this.sendAuthNumber = this.$Once(this.sendAuthNumber);
        this.regist = this.$Once(this.regist);

        const marketing_agree = localStorage.getItem('marketing_agree') ?? '';
        if (marketing_agree == '1') {
            this.agree[3] = true;
        }

        this.$GlobalStore.closeLastModal();
        if (this.$hasOwnProperty(sessionStorage, 'register_type') && !this.$GlobalStore.checkViewExist('Login')) {
            this.$GlobalStore.addModal('MemberRegistStepTwo', { isModalBackTransparent: true, transitionName: 'bottom', register_type: parseInt(sessionStorage.getItem('register_type')), id: this.id, mode: this.mode, isFromKaKaoRegist: true });
        } else {
            this.$GlobalStore.addModal('SignupCommonFrame', { type: "REGIST_TYPE", id: this.id, isFromKaKaoRegist: true, platform: this.mode })
            // this.$GlobalStore.addModal('MemberTypeSelect', {isModalBackTransparent: true, transitionName: 'bottom', completeAction : (register_type) => {
            //         this.$GlobalStore.addModal('MemberRegistStepTwo', { isModalBackTransparent: true, transitionName: 'bottom', register_type : register_type, id : this.id, mode : this.mode, isFromKaKaoRegist : true});
            //     }
            // })
        }
    }

}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
}

.label_wrap {
    padding: 0px 15px;
    margin-top: 20px;
}

.agree_check_wrap {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

.agree_content {
    flex: 1;
    font-size: 12px;
    color: #606060;
}


.input_explain {
    color: #808080;
    font-size: 10px;
    margin-top: 12px;
    margin-bottom: 20px;
}

.check_border {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #D9D9D9;
    position: relative;
    border-radius: 3px;
}

.check_img {
    width: 13px;
    height: 10px;
    position: absolute;
    top: 0px;
}

.regist_btn {
    margin-top: 40px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #D9D9D9;
    color: white;
    font-weight: 500;
    border-radius: 5px;
    text-align: center;
}

.regist_btn.active {
    background-color: #ff6100
}
</style>